import React, { useState } from 'react'
import moment from 'moment'
import DeleteStore from '../action/DeleteStore'
import EditStore from '../action/EditStore'
import MapSku from './MapSku'

const TableRow = ({ item, reload, listProductType, setModal, getDetailStore, listStore }) => {

    const [tooltipDelete, setTooltipDelete] = useState(false)
    const [tooltipEdit, setTooltipEdit] = useState(false)
    const [isShow, setIsShow] = useState(false)

    const _handleToggleTooltipDelete = () => {
        setTooltipDelete(!tooltipDelete)
    }

    const _handleToggleTooltipEdit = () => {
        setTooltipEdit(!tooltipEdit)
    }

    const _handleChangeShow = () => {
        setIsShow(!isShow)
    }

    return (
        <tr className='TableRow'>
            <td className='StoreName'>{item.namespace || ''}</td>
            <td className='Sku'>
                <MapSku
                    item={item}
                    isShow={isShow}
                    handleChangeShow={_handleChangeShow}
                    limit={440}
                />
            </td>
            <td className='Updated'>
                {!!item.updated_at ? moment(item.updated_at).format('DD/MM/YYYY HH:mm:ss') : ''}
            </td>
            <td className='Action'>
                <DeleteStore
                    tooltipDelete={tooltipDelete}
                    handleToggleTooltipDelete={_handleToggleTooltipDelete}
                    item={item}
                    reload={reload}
                />
                <EditStore
                    tooltipEdit={tooltipEdit}
                    handleToggleTooltipEdit={_handleToggleTooltipEdit}
                    item={item}
                    listProductType={listProductType}
                    setModal={setModal}
                    reload={reload}
                    getDetailStore={getDetailStore}
                    listStore={listStore}
                />
            </td>
        </tr>
    )
}

export default TableRow